import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { environment } from 'src/environments/environment';

import { defineCustomElements } from '@soctrip-common/discount-selector/loader';
defineCustomElements(window);

import { defineCustomElements as defineCustomElementsActivityPanel } from '@soctrip-common/order-activity-panel/loader';
defineCustomElementsActivityPanel(window);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // providers: [MessageService],
})
export class AppComponent {
  smallScreen = 1439;
  isSmallScreen: boolean = false;
  sidebarVisible: boolean = false;
  environment = environment;
  environmentURL?: string = environment.FE_URL_SALE;
  shopURL?: string;
  iframeUrl: SafeResourceUrl;

  constructor(
    private primeNGConfig: PrimeNGConfig,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.primeNGConfig.setTranslation({
      firstDayOfWeek: 1,
    });

    this.shopURL = `${this.environmentURL}shopping`;
    this.iframeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
      `${environment.ADMIN_HUB_URL}/app-connect`,
    );
    this.listentMessage();
  }
  listentMessage() {
    const broadcast = new BroadcastChannel('notification_channel');
    broadcast.addEventListener('message', (event) => {
      if (event.data.type === 'EMIT_SOUND_NOTIFICATION') {
        event.data.data.map((sound: string, index: number) => {
          setTimeout(() => {
            const audio = new Audio(sound);
            audio.play().catch(() => {
              console.warn('[Client]: Cannot play sound notification!');
            });
          }, index * 2000);
        });
      }
    });
  }
  onActivate() {
    window.scroll({
      top: 0,
      left: 0,
    });
  }

  checkSmallScreen() {
    this.isSmallScreen = window.innerWidth <= this.smallScreen;
  }

  isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
    input !== null && input.tagName === 'IFRAME';

  handleOnLoad = () => {
    const frame = document.getElementById('socialLogin');
    if (this.isIFrame(frame) && frame.contentWindow) {
      frame.contentWindow.postMessage({ type: 'connect' }, '*');
    }
  };
}
